
import { useRef, useState, useEffect } from "react";
import DetailAccentCard, {
	DetailSectionHeading,
} from "../../../common/detail/DetailAccentCard";
import Episode from "./Episode";

export default function EpisodeSection({ workshop, onReloadNeeded }) {
	const episodeRefs = useRef({});
	const [lastOpenEpisodeIndex, setLastOpenEpisodeIndex] = useState(null);
	const lastOpenEpisodeIndexRef = useRef(null);

	useEffect(() => {
		lastOpenEpisodeIndexRef.current = lastOpenEpisodeIndex;
	}, [lastOpenEpisodeIndex]);

	const handleOpenEpisode = (index) => {
		if (lastOpenEpisodeIndexRef.current == index) {
			return;
		}
		if (lastOpenEpisodeIndexRef.current !== null) {
			let episode = episodeRefs.current[lastOpenEpisodeIndexRef.current];
			if (episode) {
				episode.close();
			}
		}
		setLastOpenEpisodeIndex(index);
	};

	if (!workshop.episodes?.length) {
		return null;
	}

	return (
		<DetailAccentCard ariaLabel="جلسات کارگاه" bodyClassName="p-5 md:p-6">
			<DetailSectionHeading className="mb-4">جلسات</DetailSectionHeading>
			<div className="flex flex-col gap-3">
				{workshop.episodes.map((episode, index) => (
					<Episode
						key={episode.id ?? index}
						ref={(el) => {
							episodeRefs.current[index] = el;
						}}
						episode={episode}
						isOwner={workshop.is_owner}
						index={index}
						onReloadNeeded={onReloadNeeded}
						onOpen={() => {
							handleOpenEpisode(index);
						}}
					/>
				))}
			</div>
		</DetailAccentCard>
	);
}
